










































































































































































































import Vue from "vue";
import { Component, Prop, Emit, Watch, Ref } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import FactorGroupScoringDefinition from "@/components/scoring-definition/FactorGroupScoringDefinition.vue";
import SimpleMenuTextEditor from "@/components/common/SimpleMenuTextEditor.vue";
import ConfirmationDialog from "@/components/common/ConfirmationDialog.vue";
import { Factor, FactorGroup } from "@/api/model/FactorResource";
import Modelling from "@/store/modules/Modelling";
import ValueTypes from "@/utils/ValueTypes";
import * as rules from "@/rules";
import _ from "lodash";
import { NotificationEventBus } from "@/EventBus";
import CardTitle from '@/components/common/CardTitle.vue';

const modellingModule = getModule(Modelling);

@Component({
    components: {
        FactorGroupScoringDefinition,
        SimpleMenuTextEditor,
        ConfirmationDialog,
        CardTitle
    },
})
export default class TableEditor extends Vue {
    private readonly VALUE_TYPES = ValueTypes.VALUE_TYPES;
    private readonly TEXT_FORMATS = ValueTypes.TEXT_FORMATS;
    private readonly SUMMARY_SCORING_FUNCTIONS = ValueTypes.SUMMARY_SCORING_FUNCTIONS;
    private readonly DATE_TIME_FORMATS = ValueTypes.DATE_TIME_FORMATS;
    private readonly CATEGORY_FORMATS = ValueTypes.CATEGORY_FORMATS;
    @Ref()
    private createFormRef: HTMLFormElement;

    private createDialog = false;
    private updating = false;
    private rules = rules;
    private resultData: any;
    private createForm = {
        name: "",
        valuePrefix: "",
        valueTypeInformation: {
            valueType: "",
            display: "",
            valueSubType: undefined,
        },
        valueSuffix: "",
        summaryScoringFunction: "WEIGHTED_SUM",
        format: "",
        categoricalValues: [],
    };
    //
    @Prop({ default: {} })
    element: FactorGroup;

    @Prop({ default: "", type: String })
    name: string;

    @Prop({ default: "", type: String })
    type: string;

    @Prop({default: false, type: Boolean})
    customize: boolean

    get factors() {
        return modellingModule.workingModelFactorResources;
    }

    @Watch("element")
    private updateForm() {
        if (this.element) {
            this.updateFormData();
        }
    }
    @Watch("createForm.valueTypeInformation.valueType")
    private updateFormat() {
        if (this.createForm.valueTypeInformation?.display === "CATEGORICAL") {
            this.createForm.format = "DROP_DOWN";
        } else if (this.createForm.valueTypeInformation?.display === "DATE AND TIME") {
            this.createForm.format = "YYYY-MM-DD HH:mm:ss";
        }
    }

    mounted() {
        if (this.element) {
            this.updateFormData();
        }
    }

    private update() {
        if (this.createFormRef.validate()) {
            console.log("yes");
            this.updating = true;
            NotificationEventBus.emitProcessingMessage();
            this.updateFactorGroup().then((res) => {
                this.updating = false;
                NotificationEventBus.emitSuccessMessage();
            });
            this.cancel();
        }
    }

    private clear() {
         this.createForm = {
        name: "",
        valuePrefix: "",
        valueTypeInformation: {
            valueType: "",
            display: "",
            valueSubType: undefined,
        },
        valueSuffix: "",
        summaryScoringFunction: "WEIGHTED_SUM",
        format: "",
        categoricalValues: [],

    };
    }
    async updateFactorGroup() {
        let factorGroup = this.element;
        let form = this.createForm;
        factorGroup.name = form.name;
        const valueType = form.valueTypeInformation.valueType;
        const valueSubType = form.valueTypeInformation.valueSubType;
        factorGroup.groupTypeDefinition.valueTypeDefinition = {};
        factorGroup.groupTypeDefinition.valueTypeDefinition.valueType = valueType;
        factorGroup.groupTypeDefinition.valueTypeDefinition.valueSubType = valueSubType;
        factorGroup.groupTypeDefinition.valueTypeDefinition.valuePrefix = form.valuePrefix;
        factorGroup.groupTypeDefinition.valueTypeDefinition.valueSuffix = form.valueSuffix;
        factorGroup.groupTypeDefinition.valueTypeDefinition.categoricalValues =
            form.valueTypeInformation.valueType === "CATEGORICAL"
                ? _.uniq(form.categoricalValues)
                : null;
        factorGroup.groupTypeDefinition.valueTypeDefinition.format =
            form.valueTypeInformation.valueType === "DATE_TIME" ||
            form.valueTypeInformation.valueType === "CATEGORICAL" ||
            form.valueTypeInformation.valueType === "TEXT"
                ? form.format
                : null;
        factorGroup.summaryScoringFunction = form.summaryScoringFunction || "WEIGHTED_SUM";
        console.log(factorGroup);
        // update each of the factors within factor group(column)
        let factortasks = [];
        // update all the factors in the column
        if (factorGroup.hasOwnProperty("childrenIds") && factorGroup.childrenIds.length > 0) {
            factorGroup.childrenIds.forEach((x: string) => {
                if (this.factors[x].type === "FACTOR") {
                    let factor: Factor = this.factors[x] as Factor;
                    factor.valueTypeDefinition.valueType = valueType;
                    factor.valueTypeDefinition.valueSubType = valueSubType;
                    factor.valueTypeDefinition.valuePrefix = form.valuePrefix;
                    factor.valueTypeDefinition.valueSuffix = form.valueSuffix;
                    factor.valueTypeDefinition.categoricalValues =
                        form.valueTypeInformation.valueType === "CATEGORICAL"
                            ? _.uniq(form.categoricalValues)
                            : null;
                    factor.valueTypeDefinition.format =
                        form.valueTypeInformation.valueType === "DATE_TIME" ||
                        form.valueTypeInformation.valueType === "CATEGORICAL"
                            ? form.format
                            : null;
                    factortasks.push(this.updateFactor(factor));
                }
            });
        }
        await Promise.all(factortasks);
        await this.updateGroup(factorGroup, true);
    }
    // function to update factor
    // @param factor: Factor
    private async updateFactor(factor: Factor) {
        await modellingModule.updateFactorResource(factor);
    }

    // update db factor
    async updateGroup(factorGroup: FactorGroup, isDefault?: boolean) {
        await modellingModule.updateFactorResource(factorGroup).then((res) => {});
    }

    @Emit("cancel")
    private cancel() {
        this.createDialog = false;
    }

    // update column automatically
    private updateFormData() {
        // console.log(this.element);
        this.createForm.name = this.element.name;
        this.createForm.valuePrefix = this.element.groupTypeDefinition.valueTypeDefinition.valuePrefix;
        this.createForm.valueTypeInformation = this.getValueTypeInformation(
            this.element.groupTypeDefinition.valueTypeDefinition.valueType,
            this.element.groupTypeDefinition.valueTypeDefinition.valueSubType
        ) as { valueType: string; valueSubType: string; display: string };

        this.createForm.valueSuffix = this.element.groupTypeDefinition.valueTypeDefinition.valueSuffix;
        this.createForm.summaryScoringFunction = this.element.summaryScoringFunction;
        this.createForm.format = this.element.groupTypeDefinition.valueTypeDefinition.format;
        this.createForm.categoricalValues =
            this.element.groupTypeDefinition.valueTypeDefinition.valueType === "CATEGORICAL"
                ? _.uniq(this.element.groupTypeDefinition.valueTypeDefinition?.categoricalValues)
                : [];
    }

    private getValueTypeInformation(valueType: string, valueSubType: string) {
        // console.log(valueType);
        // console.log(valueSubType);
        if (valueType) {
            var type = this.VALUE_TYPES.find(
                (x: any) => x.valueType === valueType && x.valueSubType == valueSubType
            );
            return type;
        } else {
            return null;
        }
    }
    private getValueTypeInformationObject(display: string) {
        if (this.VALUE_TYPES) {
            return this.VALUE_TYPES.find((x: any) => x.display === display);
        } else {
            return null;
        }
    }
}
